export default class Fetch {
    
    constructor(sdk) {
        this.sdk = sdk;
        this.globalHeaders = [];
    }
    
    addGlobalHeader(key, value) {
        this.globalHeaders.push({ key, value})
    }

    removeGlobalHeader(key) {
        for(var i in this.globalHeaders) {
            if(this.globalHeaders[i].key == key)
                delete this.globalHeaders[i];
        }
    }
    
    async run(uri, params) {
        this.sdk.event().emit('fetchStarted');
        if (!params.headers)
            params.headers = new window.Headers();
        for(var i in this.globalHeaders) {
            params.headers.append(this.globalHeaders[i].key, this.globalHeaders[i].value);
        }
        if(!params.contentType)
            params.headers.append('Content-Type', 'application/json');
        else   
            params.headers.append('Content-Type', params.contentType);
        const response = await window.fetch('//' + this.sdk.getApiUrl() + uri, params);
        let res;
        if(!params.contentType)
            res = await response.json();
        else
            res = response;
        this.sdk.event().emit('fetchFinished');
        return res;
    }
    
    async get(uri, params = {}) {
        params.method = 'GET'
        return await this.run(uri, params);
    }
    
    async post(uri, params = {}) {
        params.method = 'POST';
        params.body = JSON.stringify(params.body);
        return await this.run(uri, params);
    }
    
    async put(uri, params = {}) {
        params.method = 'PUT';
        params.body = JSON.stringify(params.body);
        return await this.run(uri, params);
    }
    
    async delete(uri, params = {}) {
        params.method = 'DELETE';
        return await this.run(uri, params);
    }

    sendBeacon(uri, params) {
        navigator.sendBeacon('//' + this.sdk.getApiUrl() + uri, JSON.stringify(params));
    }

    
}